"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PreservationTable_1 = require("../modules/PreservationTable");
var AgePensionBasis_1 = require("../modules/AgePensionBasis");
var PAYGIncomeTaxBasis_1 = require("../modules/PAYGIncomeTaxBasis");
var Gender_1 = require("./Gender");
var index_1 = require("../index");
var Helpers = (function () {
    function Helpers(parameters) {
        this.p = parameters;
        this.tax = new PAYGIncomeTaxBasis_1.PAYGIncomeTaxBasis();
        this.wageInflation = new index_1.IndexationBasis();
        this.wageInflation.initialise(this.p.getParamObject("WageInflationIndex"));
        this.tax.initialise(parameters, this.p.getParamBoolean("Married"), this.wageInflation);
    }
    Helpers.prototype.get_DateOfBirth = function () {
        return this.dateOfBirth(this.p.getParamNumber("AgeNow"));
    };
    Helpers.prototype.get_DateOfBirth_2 = function () {
        return this.dateOfBirth(this.p.getParamNumber("AgeNow_2"));
    };
    Helpers.prototype.get_PreservationAge = function () {
        return this.preservationAge(this.get_DateOfBirth());
    };
    Helpers.prototype.get_PreservationAge_2 = function () {
        return this.preservationAge(this.get_DateOfBirth_2());
    };
    Helpers.prototype.get_AgePensionAge = function () {
        return this.agePensionAge(this.p.getParamString("Sex"), this.get_DateOfBirth());
    };
    Helpers.prototype.get_AgePensionAge_2 = function () {
        return this.agePensionAge(this.p.getParamString("Sex_2"), this.get_DateOfBirth_2());
    };
    Helpers.prototype.get_LifeExpectancy = function () {
        return this.lifeExpectancy(this.p.getParamNumber("AgeNow"), this.p.getParamString("Sex"));
    };
    Helpers.prototype.get_LifeExpectancy_2 = function () {
        return this.lifeExpectancy(this.p.getParamNumber("AgeNow_2"), this.p.getParamString("Sex_2"));
    };
    Helpers.prototype.currentTakeHomePay = function () {
        return this.p.getParamNumber("Salary") -
            this.tax.taxPayable(this.p.getParamString("Sex"), this.get_DateOfBirth(), this.p.getParamNumber("AgeNow"), this.p.getParamNumber("Salary"));
    };
    Helpers.prototype.currentTakeHomePay_2 = function () {
        return this.p.getParamNumber("Salary_2") -
            this.tax.taxPayable(this.p.getParamString("Sex_2"), this.get_DateOfBirth_2(), this.p.getParamNumber("AgeNow_2"), this.p.getParamNumber("Salary_2"));
    };
    Helpers.prototype.dateOfBirth = function (ageNow) {
        return this.p.getParamObject("CalculationDate").plus(-0.5 - ageNow);
    };
    Helpers.prototype.preservationAge = function (dateOfBirth) {
        return PreservationTable_1.PreservationTable.createDefault().preservationAge(dateOfBirth);
    };
    Helpers.prototype.lifeExpectancy = function (ageNow, sex) {
        var lifeTable = this.p.getParamObject("AbsLifeTable");
        var gender = Gender_1.Gender.fromString(sex);
        var age = Math.max(ageNow, lifeTable.startAge);
        var yearsLeft = Math.floor(lifeTable.lifeExpectancy(age, gender));
        return age + yearsLeft;
    };
    Helpers.prototype.agePensionAge = function (sex, dateOfBirth) {
        for (var i = 60; i < 100; i++) {
            if (AgePensionBasis_1.AgePensionBasis.isQualifyingAgeForAgePension(sex, dateOfBirth, i)) {
                return i;
            }
        }
    };
    return Helpers;
}());
exports.Helpers = Helpers;
//# sourceMappingURL=Helpers.js.map